module.exports = __webpack_public_path__ + "static/media/icon_mp_reOn.b3f57ef2.svg";